import beforeSetup from './before'
import afterSetup from './after'

export default () => {
  beforeSetup()
  afterSetup()
}



// WEBPACK FOOTER //
// ./src/router/setup/index.js